import BuilderBudgetTargetDemographic from './Demographic'
import BuilderBudgetTargetDemographicHeadline from './Headline'

export { BuilderBudgetTargetDemographicHeadline }
export default BuilderBudgetTargetDemographic
